<template>
     <div class="card Card">
        <div class="Card__header" v-if="showHeader">
            <h4 class="header2 title no-margin Card__title">{{title}} 
                 <span v-if="showActions" @click="clearFilter()" class="clear-filter">Limpar</span>
            </h4>
             
        </div>
        <div class="padding-7">
            <slot name="content"></slot>
            <slot></slot>
        </div>
    </div>

</template>

<style lang="scss">
@import './Card.scss';
</style>

<script>
export default{
    name: 'Card',
    data:() => ({

    }),
    props:{
        title: {
            type: String,
            default: 'Não informado',
        },
        showHeader: {
            type: Boolean,
            default: true
        },
        showActions:{
            type: Boolean,
            default: false
        }
    },
    methods:{
        clearFilter(event){
            this.$emit('clearFilter');
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/common/Card/Card.vue